var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60002 9.60002L11.4 11.4L15.6 7.20002M11.687 16.5913L6.67828 21.6V16.5913H4.80002C3.47454 16.5913 2.40002 15.5168 2.40002 14.1913V4.80003C2.40002 3.47454 3.47454 2.40002 4.80002 2.40002H19.2C20.5255 2.40002 21.6 3.47454 21.6 4.80002V14.1913C21.6 15.5168 20.5255 16.5913 19.2 16.5913H11.687Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.27b578bc78a3fd5a039d3c60de826db0.svg";
export { ForwardRef as ReactComponent };